<template>
  <v-container v-show="showWarningMessage">
    <v-layout>
      <v-flex>
        <v-snackbar
          v-model="showWarningMessage"
          color="orange"
          multi-line
          top
          :timeout="warningMessageTimeout"
        >
          {{ warningMessage }}
          <template #action="{ attrs }">
            <v-btn text @click="showWarningMessage = false" v-bind="attrs">
              {{ $t("common.CLOSE") }}
            </v-btn>
          </template>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as types from "@/store/mutation-types";

export default {
  name: "SuccessMessage",
  computed: {
    showWarningMessage: {
      get() {
        return this.$store.state.warning.showWarningMessage;
      },
      set(value) {
        this.$store.commit(types.SHOW_WARNING, value);
      },
    },
    warningMessage() {
      if (this.$store.state.warning.warningMessageParams) {
        return this.$i18n.t(this.$store.state.warning.warningMessage, [
          ...this.$store.state.warning.warningMessageParams,
        ]);
      }
      return this.$i18n.t(this.$store.state.warning.warningMessage);
    },
    warningMessageTimeout() {
      return this.$store.state.warning.warningMessageTimeout;
    },
  },
  watch: {
    warningMessage() {
      setTimeout(() => {
        this.showWarningMessage = this.warningMessage !== "";
      }, 100);
    },
  },
};
</script>
